import React from "react";
import { Box } from "react-bulma-components";
import { Columns } from "react-bulma-components";
import useInput from "../../../hooks/useInput";
import usePostVehicleType from "../../../hooks/usePostVehicleType";
import { Button } from "react-bulma-components";
import Collapsible from "react-collapsible";

function VehicleType() {
  let [vehicleType, nameInput] = useInput({
    type: "text",
    label: "Vehicle Name"
  });
  let [labourRate, labourInput] = useInput({
    type: "number",
    label: "Special Labour Rate"
  });

  let [fixedHireCosts, fixedHireCostsInput] = useInput({
    type: "number",
    label: "Fixed Hire Costs"
  });

  fixedHireCosts = parseFloat(fixedHireCosts);

  const [, postVehicleType] = usePostVehicleType({
    name: vehicleType,
    special_labour_rate: labourRate,
    fixed_hire_costs: fixedHireCosts
  });

  const handleSubmit = () => {
    postVehicleType();
  };

  return (
    <Box className="settings_type">
      <Collapsible
        className="title"
        triggerOpenedClassName="title"
        trigger="Add Vehicle Type"
      >
        <Columns>
          {nameInput}
          {labourInput}
          {fixedHireCostsInput}
        </Columns>
        <Columns>
          <Columns.Column>
            <Button onClick={handleSubmit} fullwidth color={"success"}>
              Add
            </Button>
          </Columns.Column>
        </Columns>
      </Collapsible>
    </Box>
  );
}

export default VehicleType;
